

export default class InputHelpers {

    static onFocusBrowserAutoFillDisabled = (event) =>{
        if (event.target.autocomplete) {
            event.target.autocomplete = "DisabledAC"
        }
    };
}